import { AppProviders } from './app/AppProviders';
import { AppRouter } from './app/AppRouter';
import { RouteLoadingFallback } from './app/route-loading-fallback';
import { initSentry } from './app/sentry';
import { useAppInitialization } from './hooks/useAppInitialization';
import './styles/index.css';
import './styles/toast.css';

initSentry();

/**
 * Entry point for the BestHuman portal.
 * Handles top-level provider orchestration and app-wide initialization.
 */
export function App() {
  const { isReady, isAuthenticated } = useAppInitialization();

  if (!isReady) {
    return <RouteLoadingFallback />;
  }

  return (
    <AppProviders>
      <AppRouter isAuthenticated={isAuthenticated} />
    </AppProviders>
  );
}
